import Message from "../../message";
import {useMainStore} from "@/store";

export default class MemberOnline extends Message
{
    handle()
    {
        useMainStore().SET_GUILD_MEMBER_ONLINE(this.message.id);
    }
}
